import { kemsuWebSystemBridgeUrl, kemsuWebSystemUrl } from "./constants"

/**
 * Используется для получения данных из системы на KemsuWeb через обмен сообщениеми с iframe
 * @param htmFileName имя файла, расположенного в папке по адресу {@link kemsuWebSystemBridgeUrl}
 */
export function requestToKemsuWebSystem(
	htmFileName : string,
): Promise<string | number | ErrorEvent> {
	return new Promise((resolve, reject) => {
		const iframe = document.createElement("iframe")
		iframe.style.display = "none"
		iframe.name = Date.now().toString()
		iframe.src = `${kemsuWebSystemBridgeUrl}/${htmFileName}.htm`

		const handler = (e) => {
			if (
				e.origin !== kemsuWebSystemUrl ||
				e.source !== iframe.contentWindow
			)
				return

			resolve(e.data)
			iframe.parentNode?.removeChild(iframe)
			window.removeEventListener("message", handler)
		}

		window.addEventListener("message", handler, false)

		iframe.addEventListener("load", () => {
			iframe.contentWindow?.postMessage(null, "*")
		})

		iframe.addEventListener("error", (err) => {
			reject(err)
			iframe.parentNode?.removeChild(iframe)
			window.removeEventListener("message", handler)
		})

		document.body.appendChild(iframe)
	})
}
